import { ajaxWrapper } from "functions";
import load_icon_from_monster from "pages/session_tools/global_data/load_icon_from_monster.js";

function remove_location(location) {
	console.log("Remove Location", location);
	var id = location.id;
	var location_dict = window.secret_react_state.locations;
	delete location_dict[id];

	var parent_children = [];
	var parent = location_dict[location.parent_id];
	if (parent) {
		for (var child of parent.children) {
			if (child.id == location.id) {
				continue;
			} else {
				parent_children.push(child);
			}
		}
		parent.children = parent_children;
		location_dict[location.parent_id] = parent;
	}

	if (window.secret_react_state.selected_monster_instance.id == location.id) {
		window.secret_react_state.setGlobalState("selected_monster_instance", null);
	}

	window.secret_react_state.setGlobalState("locations", location_dict);
}

export default remove_location;
